import { Component, Input } from '@angular/core';
import { WheelItemComponent } from './wheel-item/wheel-item.component';
import { ComplianceData } from '../../../shared/models/compliance-data.model';
import { COMMON_IMPORTS } from '../../../shared/imports/common-imports';

@Component({
  selector: 'app-graph-view',
  standalone: true,
  imports: [WheelItemComponent, COMMON_IMPORTS],
  templateUrl: './graph-view.component.html',
  styleUrl: './graph-view.component.scss',
})
export class GraphViewComponent {
  @Input() data: ComplianceData[] = [];
}
